"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "torre-de-busi": {
    "87ba57b9": [{
      "hkey": "efba8b27",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "efba8b27",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5d6b3233": [{
      "hkey": "2f5c988b",
      "slug": "san-gottardo",
      "name": "San Gottardo",
      "primary": true,
      "skipSearch": false
    }],
    "9098506a": [{
      "hkey": "24355277",
      "slug": "valcava",
      "name": "Valcava",
      "primary": true,
      "skipSearch": false
    }],
    "a2b6be3a": [{
      "hkey": "efba8b27",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "c5343245": [{
      "hkey": "e911f659",
      "slug": "torre-de-busi",
      "name": "Torre de' Busi",
      "primary": true,
      "skipSearch": false
    }],
    "d664d9c7": [{
      "hkey": "0ae2b397",
      "slug": "san-marco",
      "name": "San Marco",
      "primary": true,
      "skipSearch": false
    }],
    "dddc9b66": [{
      "hkey": "de797d25",
      "slug": "sogno",
      "name": "Sogno",
      "primary": true,
      "skipSearch": false
    }],
    "f0010f6c": [{
      "hkey": "d4164ac7",
      "slug": "favirano",
      "name": "Favirano",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;